import { Dispatch, SetStateAction } from "react";
import { FormControl, FormField, FormItem, FormLabel, FormMessage } from "@/components/ui/form";

import { AddDeviceIds } from "./AddDevices";
import { Checkbox } from "@/components/ui/checkbox";
import { CityInput } from "types";
import { Input } from "@/components/ui/input";
import { useFormContext } from "react-hook-form";

interface DataProviderProps {
  enableProvider: boolean;
  setEnableProvider: Dispatch<SetStateAction<boolean>>;
}

export const DataProvider = ({ enableProvider, setEnableProvider }: DataProviderProps) => {
  const { control } = useFormContext<CityInput>();

  return (
    <div className="px-4 pt-4 pb-2 space-y-4">
      <div className="flex items-center space-x-2">
        <Checkbox
          id="dataProvider"
          checked={enableProvider}
          onCheckedChange={(checked) => setEnableProvider(!!checked)}
        />
        <label htmlFor="dataProvider" className="text-sm font-medium leading-none">
          Activer le fournisseur de données
        </label>
      </div>
      {enableProvider && (
        <>
          <FormField
            control={control}
            name="dataProviderName"
            render={({ field }) => (
              <FormItem>
                <FormLabel>Nom</FormLabel>
                <FormControl>
                  <Input {...field} />
                </FormControl>
                <FormMessage />
              </FormItem>
            )}
          />
          <AddDeviceIds />
        </>
      )}
    </div>
  );
};
